import { create } from "zustand";

export type StatusFilter = "active" | "pending" | "sold" | "all" | "saved";
export type SortOption = "match" | "recency";
// "hide_uninterested" keeps undecided listings visible; it only drops the ones
// explicitly marked not interested.
export type InterestFilter = "hide_uninterested" | "interested" | "uninterested" | "all";

export interface ListingsFilters {
  status: StatusFilter;
  town: string[];
  interest: InterestFilter;
  sortBy: SortOption;
  minPrice: number | null;
  maxPrice: number | null;
  minSqft: number | null;
  minBeds: number | null;
  minBaths: number | null;
  minSchoolScore: number | null;
}

export const DEFAULT_FILTERS: ListingsFilters = {
  status: "active",
  town: [],
  interest: "hide_uninterested",
  sortBy: "recency",
  minPrice: null,
  maxPrice: null,
  minSqft: null,
  minBeds: null,
  minBaths: null,
  minSchoolScore: null,
};

interface ListingsState {
  filters: ListingsFilters;
  highlightedIds: Set<string>;
  setFilters: (next: Partial<ListingsFilters>) => void;
  resetFilters: () => void;
  setHighlight: (ids: string[]) => void;
  clearHighlight: () => void;
}

export const useListingsStore = create<ListingsState>((set) => ({
  filters: DEFAULT_FILTERS,
  highlightedIds: new Set(),
  setFilters: (next) => set((s) => ({ filters: { ...s.filters, ...next } })),
  resetFilters: () => set({ filters: DEFAULT_FILTERS }),
  setHighlight: (ids) => set({ highlightedIds: new Set(ids) }),
  clearHighlight: () => set({ highlightedIds: new Set() }),
}));
